import "core-js/modules/es.array.at.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.string.at-alternative.js";
import UpdatePassword from "@/components/Modal/UpdatePassword.vue";
import InitPassword from "@/views/MGT/passwordModal/passwordModal.vue";
import { auth } from "@/service/cas.js";
import MyInfo from "@/components/Modal/MyInfo.vue";
import Protection from "@/components/Modal/Protection.vue";
import ValidMFA from "@/components/Modal/ValidMFA.vue";
import userInitLogo from "@/assets/user.png";
import { mapActions, mapState } from "vuex";
import { getUnitNumber } from "@/libs/auth";
import { version } from "@/service/log";
import { getUserInfo } from "@/service/user";
import { open } from "@/libs/common.js";
import { getServerConfigValue } from "@/service/server";
export default {
  name: "user-message",
  components: {
    UpdatePassword,
    InitPassword,
    MyInfo,
    Protection,
    ValidMFA
  },
  data() {
    return {
      userInitLogo,
      dropdownVisible: false,
      myInfo: {
        visible: false
      },
      password: {
        visible: false
      },
      closeable: true,
      config: null
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      personalConfig: state => state.user.personalConfig,
      unitCategoryMap: state => state.app.unitCategoryMap,
      unitColorMap: state => state.app.unitColorMap,
      isMobile: state => state.app.isMobile
    }),
    userLogo() {
      var _this$user;
      let logo = ((_this$user = this.user) === null || _this$user === void 0 || (_this$user = _this$user.userInfo) === null || _this$user === void 0 ? void 0 : _this$user.picture) || userInitLogo;
      return logo;
    },
    type() {
      var _this$unitCategoryMap, _this$unitColorMap$fi;
      let text = ((_this$unitCategoryMap = this.unitCategoryMap.find(item => {
        var _this$user2;
        return item.code === ((_this$user2 = this.user) === null || _this$user2 === void 0 || (_this$user2 = _this$user2.userInfo) === null || _this$user2 === void 0 ? void 0 : _this$user2.unitType);
      })) === null || _this$unitCategoryMap === void 0 ? void 0 : _this$unitCategoryMap.value) || "";
      let color = ((_this$unitColorMap$fi = this.unitColorMap.find(item => {
        var _this$user3;
        return item.code === ((_this$user3 = this.user) === null || _this$user3 === void 0 || (_this$user3 = _this$user3.userInfo) === null || _this$user3 === void 0 ? void 0 : _this$user3.unitType);
      })) === null || _this$unitColorMap$fi === void 0 ? void 0 : _this$unitColorMap$fi.value) || "";
      let [pre, next] = color.split(",");
      return {
        text,
        pre,
        next
      };
    },
    unitNumberBoo() {
      return Number(getUnitNumber()) > 1 ? true : false;
    },
    _updatePassword() {
      var _this$user4, _this$user5;
      return ((_this$user4 = this.user) === null || _this$user4 === void 0 || (_this$user4 = _this$user4.userInfo) === null || _this$user4 === void 0 ? void 0 : _this$user4.mobile) != "" || ((_this$user5 = this.user) === null || _this$user5 === void 0 || (_this$user5 = _this$user5.userInfo) === null || _this$user5 === void 0 ? void 0 : _this$user5.email) != "";
    },
    showProtection() {
      var _this$config, _this$config2;
      return ((_this$config = this.config) === null || _this$config === void 0 ? void 0 : _this$config.state) && ((_this$config2 = this.config) === null || _this$config2 === void 0 ? void 0 : _this$config2.code);
    },
    passwordMenuText() {
      var _this$user6;
      // 未设置密码的账号菜单展示“设置密码”，避免用户误以为已有密码可修改。
      return ((_this$user6 = this.user) === null || _this$user6 === void 0 || (_this$user6 = _this$user6.userInfo) === null || _this$user6 === void 0 ? void 0 : _this$user6.shouldInitPassword) === "T" ? $t("i5ms174", "设置密码") : $t("ai7i2u4", "修改密码");
    }
  },
  methods: {
    close() {
      this.myInfo.visible = false;
    },
    setInitBizDate(visible) {
      this.dropdownVisible = visible;
    },
    closeUserDropdown() {
      // 移动端先收起头像下拉层，避免 transfer 浮层盖住随后打开的弹窗。
      this.dropdownVisible = false;
    },
    ...mapActions(["handleLogOut", "reqMFAConfigs", "reqPersonConfig"]),
    async onLogout() {
      this.closeUserDropdown();
      const res = await this.handleLogOut();
      if (res && res.result === 0) {
        this.$Message.success($t("iibymh4", "退出成功"));
        this.$router.push({
          name: "Login"
        });
      }
    },
    async updatePassword() {
      this.closeUserDropdown();
      let {
        data: {
          retVal: {
            shouldInitPassword
          }
        }
      } = await getUserInfo();
      if (shouldInitPassword === "T") {
        let tipText = {
          title: $t("i5ms174", "设置密码"),
          tip: $t("kckpk0o", "您尚未设置密码，为保护账户安全，请完成密码设置。"),
          confirmBtn: $t("fugigo4", "立即设置"),
          cancelBtn: $t("fr6dw14", "稍后设置")
        };
        this.$refs["initPasswordRef"].open(null, tipText);
      } else {
        this.$refs["updatePassword"].init();
      }
    },
    replaceUnit() {
      this.closeUserDropdown();
      this.$router.push("/login");
    },
    async protection() {
      const h = this.$createElement;
      this.closeUserDropdown();
      let personalConfig = await this.reqPersonConfig();
      let {
        bound
      } = personalConfig;
      this.$Modal.info({
        title: $t("fcbw9t4", "登录保护"),
        width: 520,
        closable: true,
        render: () => {
          return h("Alert", {
            "attrs": {
              "show-icon": true,
              "type": "info"
            }
          }, [$t("a1v0c76", "尊敬的用户："), h("span", {
            "slot": "icon"
          }, [h("Icon", {
            "attrs": {
              "type": "ios-bulb-outline"
            }
          })]), h("span", {
            "slot": "desc"
          }, [h("div", {
            "style": "display: flex; flex-direction: column; gap: 5px"
          }, [h("span", {
            "style": "text-indent: 32px;word-break:break-all"
          }, [$t("t46res1s", "为了增强您的账户安全性，我们建议您开启虚拟多因素认证。开启虚拟MFA后，您每次登录时都需输入一次安全码，进一步保护您的账户安全。")]), h("div", {
            "style": "display: flex; justify-content: end"
          }, [h("span", [`${$t("gnyy2", "当前") + $t("dv7d2", "企业") + "：" + this.user.userInfo.unitName}`])])])])]);
        },
        okText: bound ? $t("7q7myq7", "解除绑定MFA") : $t("ri4l967", "绑定虚拟MFA"),
        cancelText: "     ",
        onOk: () => {
          this.$refs["protection"].open(personalConfig);
        }
      });
    },
    validSuccess() {
      this.closable = true;
    },
    validCancel() {
      if (!this.closeable) {
        this.$router.push("/login");
      }
    },
    openMyInfo() {
      this.closeUserDropdown();
      this.$refs["myInfo"].init();
    },
    async openChangeLog() {
      this.closeUserDropdown();
      let {
        data = "origin/release/2.0.0.1"
      } = await version();
      // eslint-disable-next-line no-unused-vars
      let vs = data.split("/").at(-1);
      // eslint-disable-next-line no-unused-vars
      let versionParts = vs.split(".");
      let tag = versionParts.slice(0, 3).join(".");
      let {
        data: {
          retVal
        }
      } = await auth(`${getServerConfigValue("VUE_APP_HELP") || "http://192.168.0.85:8080/help_new_front/#/"}detail?c=JCYFB&v=IWORK${tag}&service=HELP_CENTER`);
      open(retVal, true);
    }
  },
  async mounted() {
    await this.$store.dispatch("getUserInfo");
    if (this.$store.state.user.userInfo.unitId) {
      this.$store.dispatch("getGig");
    }
    let unit = localStorage.getItem("unit");
    if (unit) {
      let {
        code
      } = JSON.parse(localStorage.getItem("unit"));
      this.config = await this.reqMFAConfigs();
      this.config.code = code;
    }
  }
};